/**
 * Query flags for the remote preview iframe: embedded deck syncs via postMessage and hides chrome.
 */

export function appendRemotePreviewQueryParams(iframeUrl: string, baseForRelative?: string): string {
  const raw = String(iframeUrl || '').trim();
  if (!raw) return raw;

  if (/^https?:\/\//i.test(raw)) {
    try {
      const u = new URL(raw);
      u.searchParams.set('postMessageEvents', 'true');
      u.searchParams.set('lecturaPreview', '1');
      u.searchParams.set('remote', '1');
      return u.href;
    } catch {
      /* fall through */
    }
  } else if (baseForRelative) {
    try {
      const u = new URL(raw, baseForRelative);
      u.searchParams.set('postMessageEvents', 'true');
      u.searchParams.set('lecturaPreview', '1');
      u.searchParams.set('remote', '1');
      return u.href;
    } catch {
      /* fall through */
    }
  }

  const sep = raw.includes('?') ? '&' : '?';
  return `${raw}${sep}postMessageEvents=true&lecturaPreview=1&remote=1`;
}
